<template>
  <div class="app-icon">
    <img 
      class="app-image"
      :alt="name"
      :src="src"
      @click="clickAppIcon()">
    <div v-if="nameDisplay"
      class="app-name">
      {{ name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppIcon',
  data: () => {
    return {
    }
  },
  props: {
    nameDisplay: Boolean,
    name: String,
    src: String
  },
  methods: {
    clickAppIcon() {
      this.$emit("clickAppIcon")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app-image {
  width: 105px;
  height: 105px;
  margin: 5px 10px;
  border-radius: 25px;
  transition-duration: 0.2s;
}
.app-image:hover {
  cursor: pointer;
  filter: grayscale(1);
}
.app-name {
  margin: 4px 2px 10px;
  font-weight: bold;
  font-size: 1.05rem;
  text-align: center;
}
</style>
